export default class SocialIconsListShareButtons {
    static init() {
        document.addEventListener('click', (e) => {
            if (e.target && e.target.closest('a') && e.target.closest('.social-icons-list-share-buttons')) {
                e.preventDefault();
                window.open(e.target.closest('a').getAttribute('href'), 'Share', 'width=626,height=436');
            }
        });
    }
}
